<template>
  <div>
    <div class="fixed-bottom bg-white py-3 shadow">
      <b-container fluid="xl">
        <b-row align-h="center" class="mx-lg-4 px-lg-4">
          <b-col cols="10" class="my-1">
            <b-row>
              <b-col
                lg="auto"
                :class="['mt-3 mt-lg-0 d-lg-block ml-auto', { 'd-none': showHelpButton }]"
              >
                <router-link
                  class="angle-right-icon-hover"
                  :to="{ name: 'Home' }"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <b-button
                    :href="href"
                    @click="navigate"
                    :variant="seeOtherChildrenVariant"
                    size="lg"
                    block
                    pill
                    class="font-weight-bold"
                  >
                    {{ $t('childPage.seeOtherChildren') }}
                    <i :class="`angle-right-icon ml-2 ${iconColor}`"></i>
                  </b-button>
                </router-link>
              </b-col>
              <b-col auto v-if="showHelpButton" />
              <b-col lg="4" class="mr-lg-4" v-if="showHelpButton">
                <HelpButton :name="firstNameDative" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import HelpButton from '@/components/childPage/HelpButton.vue'

type Props = {
  firstNameDative: string
  showHelpButton: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showHelpButton: false
})

const seeOtherChildrenVariant = computed<string>(() => {
  return props.showHelpButton ? 'outline-primary' : 'primary'
})

const iconColor = computed<string>(() => {
  return props.showHelpButton ? 'bg-primary' : 'bg-white'
})
</script>
